export function buildUrl(store_path, endpoint) {
    if (!store_path || store_path.length < 1) { return endpoint };
    return `/${store_path}${endpoint}`;
}